import React from 'react';
import { Link } from 'gatsby';
// import { graphql, useStaticQuery } from "gatsby";
// import { GatsbyImage, getImage } from "gatsby-plugin-image";
import classnames from 'classnames';
import Icon from 'components/UI/Icon';
import useIntersection from 'hooks/useIntersection';
import Image from 'images/about/careers/meeting.jpg';
import * as styles from './careers.module.scss';

const Careers = ({ data }) => {
  const { scrollWrapper, inViewSec, inViewRefSec } = useIntersection({
    threshold: 0.5,
  });

  // TODO: перестала отображатся картинка с GatsbyImage
  // const { file } = useStaticQuery(graphql`
  //   query getCareersMeeting {
  //     file(relativePath: { eq: "about/careers/meeting.jpg" }) {
  //       relativePath
  //       name
  //       childImageSharp {
  //         gatsbyImageData(
  //           quality: 100
  //           backgroundColor: "#ccc"
  //           jpgOptions: { progressive: true, quality: 100 }
  //           webpOptions: { quality: 100 }
  //         )
  //       }
  //     }
  //   }
  // `);

  return (
    <section className={classnames(styles.section)} ref={scrollWrapper}>
      <div className="cr-wrap">
        <div
          className={classnames(styles.inner, inViewSec && styles.jsInitAnim)}
          ref={inViewRefSec}
        >
          <div className={classnames(styles.imgWrap)}>
            {/* // TODO: перестала отображатся картинка с GatsbyImage */}
            {/* <GatsbyImage
              image={getImage(file.childImageSharp)}
              alt={file.name}
            /> */}
            <img src={Image} alt="" />
          </div>
          <div className={classnames(styles.content)}>
            <p className={classnames('cr-subheader cr-subtitle-sec cr-text-3')}>
              {data.subtitle && data.subtitle}
            </p>
            <h2
              className={classnames(
                styles.title,
                'cr-h2 cr-subtitle-sec cr-underline-gradient'
              )}
            >
              {data.title && data.title}
            </h2>
            <p className={classnames(styles.description, 'cr-lead')}>
              {data.description && data.description}
            </p>

            <Link
              to={'#'}
              className="cr-btn cr-btn--icon cr-btn--large cr-btn--wide cr-btn--icon-red-bg"
            >
              <span>Discover career oportunities</span>
              <Icon name="corner-arrow-small-bold" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Careers;
